/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import mdClose from '@iconify/icons-ion/md-close';
import { Icon } from '@iconify/react';
import { FormattedMessage } from 'react-intl';
import ReactToPrint from 'react-to-print';
import { PrintOutlined } from '@material-ui/icons';
import moment from 'utils/moment';
import Modal from '../../../components/modal';
import SectionHeader from '../../../components/sectionHeader';
import icon from '../../../icons/badging.png';
import styles from './detail.module.scss';
import HeaderBack from '../../../components/headerBack';
import Button from '../../../components/button/button';
import Panel from '../../../components/panel';
import ApplicationInfo from './ApplicationInfo';
import { getApplication, signitoryReview, fetchApplications, clearApplicationDetails,
  rejectBadge, getSchema, getAccessAreas } from '../redux/actions';
import wstyles from '../../workorders/Detail/workOrderDetail.module.scss';
import Loading from '../../../components/loading';
import CommentContainer from '../../../components/commenContainer';
import { GetFileName, S3Uploads } from '../../services';
import Clickable from '../../../components/clickable/Clickable';
import clipboard from '../../../icons/clipboard.png';
import BadgePrint from './BadgePrint';

class ApplicationDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingStatus: false,
      isPressed: false,
      signatoryStaffSignature: [],
      signatoryStaffSignatureError: false,
      view: 'application',
      showRejectform: false,
      rejectComment: '',
      isPrintPdf: false,
      badgeDropdown: false,
      rejectError: false,
      copy: '',
      requiredMap: {},
      response: {},
      fieldErrors: {},
      showFormErrors: false,
      access_area: '',
      sub_access_areas: '',
      accessAreaError: false
    };
    this.wrapperRef = React.createRef();
    this.ActionsRef = React.createRef();
    this.slideStyles = {
      entered: { transform: 'translate3d(0px,0px)' }
    };
    this.printComponentRef = React.createRef();
    this.componentRef = React.createRef(); // Create the ref
 }

  componentDidMount() {
    const {
      actionFetchSchema,
      actionDetail,
      match: {
        params: { id }
      },
      actionAccessAreas
    } = this.props;
    actionDetail(id);
    this.setState({ loadingStatus: true });
    actionFetchSchema();
    actionAccessAreas();
  }

  componentDidUpdate(prevProps) {
    const { saveAction, actionClear, fetchApplicationAction, history, badgeReject, schema } = this.props;
    const { response } = this.state;
    if (((saveAction.success === true && prevProps.saveAction.success!==saveAction.success)
      || (badgeReject?.success === true && prevProps?.badgeReject?.success !== badgeReject?.success))) {
      history.push('/badging/List');
      actionClear();
    }
    if (
      prevProps.fetchApplicationAction.loading === true
      && fetchApplicationAction.loading === false
    ) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ loadingStatus: fetchApplicationAction.loading });
    }
      let requiredMap = {};
      let fieldErrors = {};
      const conditionalFields = {};
      const attachmentFields = [];
      const signatureFields = [];
      let fields = schema?.signatory_fields_schema?.schema?.fields;
      if (fields?.length > 0) {
        fields.forEach((detailField) => {
          if (
            detailField.type !== 'dataSource'
            && detailField.type !== 'dataSourceMultiselect'
            && detailField.type !== 'header'
            && detailField.type !== 'attachments'
          ) {
            requiredMap = {
              ...requiredMap,
              [detailField.id]: detailField.isDisabled? false :detailField.required,
              signature: false
            };
            if (!detailField.conditional) {
              fieldErrors = {
                ...fieldErrors,
                [detailField.id]: detailField.isDisabled? false :detailField.required,
                signature: false
              };
            } else {
              conditionalFields[
                detailField?.conditional_field?.key
              ] = detailField;
            }
          }
          if (detailField.type === 'attachments') attachmentFields.push(detailField.id);
          if (detailField.type === 'signature') signatureFields.push(detailField.id);
        });
      }
      if (prevProps.schema !== schema) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          fields,
          requiredMap,
          fieldErrors,
          loadingStatus: false,
          attachmentFields,
          signatureFields,
          conditionalFields,
          response: {
            ...response
          }
        });
      }
  }

  onClose = (value) => {
    this.setState({ [value]: false, loadingStatus: true });
  }

  getFileNames = async (count) => {
    const response = await GetFileName.getUploadFileName(count);
    return response;
  };

  doS3Upload = async (files, fileIds, entity) => {
    const response = await S3Uploads.uploadFiles(
      files,
      fileIds.filename,
      entity
    );
    return response;
  };

  handleReject = () => {
    this.setState({ showRejectform: true });
  };

  handleSubmit = async (value) => {
    const { user, actionSignatoryReview, match: { params: { id } }, actionRejectBadge, application, schema } = this.props;
    const { signatoryStaffSignature, rejectComment, response: { ...form_data }, fields, fieldErrors, access_area, sub_access_areas } = this.state;
    const attachmentFields = fields.filter(schemaField => (
      schemaField?.type === 'attachments'
    ));
    const signatureFields = fields.filter(schemaField => (
      schemaField?.type === 'signature'
    ));
    if (value === 'reject') {
        if (rejectComment?.length === 0) {
          this.setState({
            rejectError: true
          });
          return;
        }
        actionRejectBadge(id, { 'send_back': {
        comment: rejectComment,
        badge: application.id,
        commented_by: user.id,
        current_date: moment().format(),
        com_type: 'Rejected'
      }
      });
      this.setState({
        showRejectform: false,
        rejectError: false
      });
      return;
    }
    if (value === 'signatory_review' || value === 'sigantory_review') {
      const errors = {
        signatoryStaffSignatureError: false,
        accessAreaError: false,
        showFormErrors: false
      };
      if (signatoryStaffSignature?.length === 0) {
        errors.signatoryStaffSignatureError = true;
      }
      if (schema?.settings?.application_fill_up_privilege_type === 'signatory_staff' && (!access_area || access_area.length < 1)) {
        errors.accessAreaError = true;
        errors.showFormErrors = true;
      }
      this.setState(errors);
      // Stop form submission if any errors are present
      if (errors.signatoryStaffSignatureError || errors.accessAreaError) {
        return;
      }
    }
    const errors = { ...fieldErrors };
    let noErrors = Object.keys(errors).every(k => errors[k] === false);
    const info = {
      approved_by: user.id,
      approved_on: moment().format(),
      submitted_date: moment().format()
    };
    const contact = { ...info };
    const formData = new FormData();
    if (noErrors) {
      if (signatoryStaffSignature?.length !== 0) {
        this.setState({ loadingStatus: true });
        let fileIds = '';
        fileIds = await this.getFileNames(1);
        const data = [];
        data.push(signatoryStaffSignature);
        if (fileIds) {
          await this.doS3Upload(data, fileIds, 'signatory_review').then(() => {
            fileIds.filename.forEach((attachmentId) => {
              formData.append('signatory_review_signature', attachmentId.toString());
            });
          });
        }
        this.setState({
          signatoryStaffSignatureError: false
        });
      }
      if (attachmentFields?.length > 0) {
        for (let index = 0; index < attachmentFields?.length; index++) {
          let attachmentField = attachmentFields[index]?.id;
          const schemaField = attachmentFields[index];
          if (schemaField?.type === 'attachments') {
            if (schemaField?.type === 'attachments' && form_data[attachmentField]?.length > 0) {
              const signatoryCustomAttachments = [];
              const attachmentIDs = [];
              form_data[attachmentField].forEach((e) => {
                if (!e.id) {
                  signatoryCustomAttachments.push(e);
                }
              });
              let fileIdsC = '';
              if (signatoryCustomAttachments?.length > 0) {
                // eslint-disable-next-line no-await-in-loop
                fileIdsC = await this.getFileNames(signatoryCustomAttachments?.length);
              }
              if (fileIdsC) {
                // eslint-disable-next-line no-await-in-loop
                await this.doS3Upload(signatoryCustomAttachments, fileIdsC, 'signatoryCustomAttachments').then(
                  () => {
                    fileIdsC.filename.forEach((attachmentId) => {
                      if (attachmentId) {
                        attachmentIDs.push(attachmentId.toString());
                      }
                    });
                  }
                );
              }
              form_data[attachmentField] = attachmentIDs;
            }
          }
        }
      }
      if (signatureFields?.length) {
        await Promise.all(
          signatureFields.map(async (field) => {
            const fieldId = field?.id;
            const signatureValue = form_data[fieldId];

            if (!signatureValue) return;

            const files = Array.isArray(signatureValue) ? signatureValue : [signatureValue];
            const newFiles = files.filter(file => !file.id);

            if (!newFiles.length) return;

            const fileIds = await this.getFileNames(newFiles.length);

            if (fileIds?.filename?.length) {
              await this.doS3Upload(
                newFiles,
                fileIds,
                'signatoryCustomSignatures'
              );

              form_data[fieldId] = fileIds.filename.map(signatureId => signatureId.toString());
            }
          })
        );
      }
      contact.signatory_response = JSON.stringify(form_data);
      Object.keys(contact).forEach((k) => {
        formData.append(k, contact[k]);
      });
    if (access_area && access_area.length > 0) {
      const accessname = access_area?.map(a => a.value);
      formData.append('access_area', accessname);
    }
    if (sub_access_areas && sub_access_areas.length > 0) {
      const selected_sub_access_areas= sub_access_areas?.map(a => a.value);
      formData.append('sub_access_areas', selected_sub_access_areas);
    }
    actionSignatoryReview(id, formData);
  } else {
    this.setState({ showFormErrors: true });
  }
  }

  handleChecklist = (e, value, modal) => {
    if (e.target.checked) {
      this.setState({ [value]: true, [modal]: true });
    } else {
      this.setState({ [value]: false, [modal]: false });
    }
  }

  handleAnswerChanged = (section, answer, fieldId) => {
    if (section === 'signatory_review' || section === 'sigantory_review') {
      const newState = {};
      switch (fieldId) {
        case 'signature':
          newState.signatoryStaffSignature = answer;
          newState.signatoryStaffSignatureError = answer === '';
          break;
        case 'access_area':
          newState.access_area = answer;
          newState.accessAreaError = answer === '';
          newState.sub_access_areas = '';
          break;
        case 'sub_access_areas':
          newState.sub_access_areas = answer;
          break;
        default:
          break;
      }

      this.setState(newState);
    }
    this.setState(prevState => ({
      [section]: {
        ...prevState[section],
        [fieldId]: answer
      }
    }));
  };

  handleSaveCHecklists = (value) => {
    const { actionApplicationChecklist, match: { params: { id } } } = this.props;
    const { fingerprintInfo, chrcInfo, staInfo, rapInfo } = this.state;
    let info = {};
    info.fingerPrintData= fingerprintInfo;
    info.chrcData = chrcInfo;
    info.staData = staInfo;
    info.rapData = rapInfo;
    actionApplicationChecklist(id, info);
    this.onClose(value);
  }

  toggleStatus = () => {
    this.setState({ isPressed: !this.state.isPressed });
  };

  ops_logs = historys => historys.sort((a, b) => new Date(b.date) - new Date(a.date));

  handleViewChange = (view) => {
    this.setState({ view });
  };

  copyPublicUrl = () => {
    const { application } = this.props;
    const installationId = localStorage.getItem('portalBackendId');
    const airportCode = localStorage.getItem('airportId');
    const publicUrl = `${window.location.host}/auth/badging/login/${application?.id}/${installationId}/${airportCode}`;
       navigator.clipboard.writeText(publicUrl);
       this.setState({ copy: 'Copied!' });
  };

  handleFieldErrorChanged = (fieldId, errorValue) => {
    this.setState(prevState => ({
      ...prevState,
      fieldErrors: {
        ...prevState.fieldErrors,
        [fieldId]: errorValue
      }
    }));
  };

  render() {
    const { application, user, schema, accessAreas } = this.props;
    const { loadingStatus, isPressed, signatoryStaffSignatureError, view, showRejectform, copy, requiredMap, showFormErrors,
       response, fieldErrors, accessAreaError, access_area, sub_access_areas } = this.state;
    const installationId = localStorage.getItem('portalBackendId');
    const getStyles = () => '@page { margin: 80px 50px !important; size: portrait !important; }';
    const airportCode = localStorage.getItem('airportId');
    return (
    <>
      <Loading loadingStatus={loadingStatus} zindex="1000" />
      <div>
      <SectionHeader icon={icon} translationID="topbar.badging" defaultTitle="Badges" />
        <HeaderBack
          translationID="hazard.start.back"
          translationDefault="Back"
          backRoute="/badging/List"
        >
          {application && (application.current_stage !== 'initiated') && application.application_filled_by === 'Applicant' && (
          <div className={styles.links}>
            <Clickable
              onClick={() => this.handleViewChange('application')}
              className={view === 'application' ? styles.active : ''}
            >
              <FormattedMessage
                id="lease.tenants.settings.fieldsz"
                defaultMessage="Application"
              />
            </Clickable>
            <Clickable
              onClick={() => this.handleViewChange('acknowledgement')}
              className={view === 'acknowledgement' ? styles.active : ''}
            >
              <FormattedMessage
                id="lease.tenants.settings.business_types1"
                defaultMessage="Acknowledgement"
              />
            </Clickable>
          </div>
          )}
          {view === 'application' && (
            <>
            <ReactToPrint
            onBeforGetPrint={() => new Promise((resolve) => {
            this.setState({ isPrintPdf: true }, resolve);
            })}
              onAfterPrint={() => this.setState({
                isPrintPdf: false
              })}
              trigger={() => (
                <span
                className={styles.actionsBtn2}
                role="button"
                tabIndex={0}
                onClick={() => {}}
                onKeyPress={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    // No -op print while will be handled by react-to-print
                    }
                }}
                >
                <PrintOutlined className={styles.printButton} />
                <FormattedMessage
                  id="workorders.detail"
                  defaultMessage="Print"
                />
                </span>
              )}
              content={() => this.printComponentRef.current}
              documentTitle={`${user?.portal_airport?.name} (${user?.portal_airport?.code})`}
              />
            </>
          )}
          <div style={{ display: 'none' }}>
            <div ref={this.printComponentRef}>
              <style>{getStyles()}</style>
              <BadgePrint printData={application} userData={user} schemaData={schema} />
            </div>
          </div>

        </HeaderBack>
        <div className={`container ${styles.container}`}>
            <Panel
                containerClasses={wstyles.mainPanel}
                title="workorders.detail.3"
                defaultTitle={'Application #{id}'}
                translationValues={{ id: application?.id }}
                comments={application?.comments}
                onCommentStatus={this.toggleStatus}
            >
              <div className={styles.modalContent}>
              <Modal
                onClose={() => this.setState({ isPressed: false })}
                showIn={isPressed}
                width="60%"
                minHeight="50%"
              >
                <div className={styles.commentsHeader}>
                  <div className={styles.title}>
                    <FormattedMessage
                      id="workorders.detail.comments.header"
                      defaultMessage={'Application #{id}'}
                      values={{ id: application?.id }}
                    />
                  </div>
                  <Icon
                    icon={mdClose}
                    onClick={() => {
                      this.setState({ isPressed: !isPressed });
                    }}
                    height="20"
                    style={{ cursor: 'pointer' }}
                  />
                </div>
                <div className={styles.commentsBody}>
                  <h4>All comments</h4>
                  <div className={styles.comments}>
                    {application && application.comments && (
                      <CommentContainer
                        comments={this.ops_logs(
                          application.comments
                        )}
                      />
                    )}
                  </div>
                </div>
              </Modal>

              </div>
              {application && (
                <div className={wstyles.panelContent}>
                  {application && (application?.current_stage === 'initiated' || application?.status === 2 || application?.status === 7)
                  && application.application_filled_by === 'Applicant' && (
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                      <span className={styles.publicUrl}>
                        Public Url:
                        <span className={styles.link} style={{ marginLeft: '10px' }}>
                          <a
                          href={`/auth/badging/login/${application?.id}/${installationId}/${airportCode}`}
                          rel="noopener noreferrer"
                          target="_blank"
                          >
                            {`${window.location.host}/auth/badging/login/${application?.id}/${installationId}/${airportCode}`}
                          </a>
                        </span>
                      </span>
                      <div style={{ marginLeft: '10px' }}>
                        <img src={clipboard}
                          style={{ cursor: 'pointer', width: '20px', color: 'grey' }} alt="clipboard"
                          onClick={this.copyPublicUrl} />
                          {''}{''}<span style={{ color: 'green', margin: '8px' }}>{copy}</span>
                      </div>
                    </div>
                )}
                  <ApplicationInfo
                    application={application}
                    user={user}
                    handleAnswerChanged={this.handleAnswerChanged}
                    handleFieldErrorChanged={this.handleFieldErrorChanged}
                    error={signatoryStaffSignatureError}
                    tabSelected={view}
                    signatoryCustomFields={schema?.signatory_fields_schema}
                    requiredMap={requiredMap}
                    showFormErrors={showFormErrors}
                    response={response}
                    fieldErrors={fieldErrors}
                    settings={schema?.settings}
                    access={accessAreas}
                    accessError={accessAreaError}
                    accessArea={access_area}
                    subAccessArea={sub_access_areas}
                  />
                </div>
              )}
              <div className={`${wstyles.footer} ${wstyles.embedded}`}>
              {application && (application.current_stage === 'signatory_review'
              || application.current_stage === 'sigantory_review') && application?.status !== 2 && (
                      <div className={wstyles.buttonContainer}>
                        {user && user?.permissions?.signitory_review?.Approval && (
                        <>
                        {application?.application_filled_by === 'Applicant' && (
                          <Button
                            onClick={() => this.handleReject('reject')}
                            translationID="lease.maintenance.detail.status_mark_rejected"
                            defaultText="Reject"
                            action="danger"
                          />
                        )}
                          <Button
                            onClick={() => this.handleSubmit(application.current_stage)}
                            translationID="wildlife.form.1"
                            defaultText="Submit for Approval"
                            action="primary"
                          />
                        </>
                        )}
                      </div>
                  )}
              </div>
              <Modal showIn={showRejectform} onClose={() => this.onClose('showRejectform')} width="554px" minHeight="270px">
                <div className={styles.newTask}>
                <div style={{ display: 'flex', borderBottom: '1px solid #E6EAEE', justifyContent: 'space-between' }}>
                  <div className={styles.title}>
                    <FormattedMessage
                            id="lease.workorders.detail.comments.header"
                            defaultMessage={'Badge #{id}'}
                            values={{ id: application && application.id }}
                          />
                  </div>
                </div>
                  <div style={{ margin: '20px' }}>
                  <textarea style={{ width: '100%', height: '80px' }}
                  onChange={e => this.setState({ rejectComment: e.target.value })}
                  />
                  </div>
                  <div className={styles.notefooter} style={{ justifyContent: 'flexEnd', gap: '3%' }}>
                    <Button
                      action="default"
                      className={styles.importbtn}
                      onClick={() => this.setState({ showRejectform: false })}
                      translationID="todo.newTask.cancel"
                      defaultText="Cancel"
                    />
                    <div className={styles.saveWrapper1}>
                      <Button
                        onClick={() => this.handleSubmit('reject')}
                        translationID="lease.maintenance.detail.status_mark_rejected"
                        defaultText="Reject"
                        action="danger"
                      />
                    </div>
                  </div>
                </div>
              </Modal>
            </Panel>
        </div>
      </div>
    </>
    );
  }
}

ApplicationDetail.propTypes = {
  history: PropTypes.shape({}).isRequired,
  match: PropTypes.shape({}).isRequired
};

const mapStateToProps = state => ({
  user: state.auth.profile,
  application: state.badging.applicationdata,
  saveAction: state.badging.saveSignatoryAction,
  fetchApplicationAction: state.badging.fetchApplicationAction,
  badgeReject: state.badging.badgeReject,
  schema: state.badging.schema,
  accessAreas: state.badging.accessAreas
});

const mapDispatchToProps = dispatch => ({
  actionDetail: (id) => {
    dispatch(getApplication(id));
  },
  actionSignatoryReview: (id, data) => {
    dispatch(signitoryReview(id, data));
  },
  actionRejectBadge: (id, data) => {
    dispatch(rejectBadge(id, data));
  },
  actionFetchApplications: () => {
    dispatch(fetchApplications());
  },
  actionClear: () => {
    dispatch(clearApplicationDetails());
  },
  actionFetchSchema: () => {
    dispatch(getSchema());
  },
  actionAccessAreas: () => {
    dispatch(getAccessAreas());
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ApplicationDetail);
